// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3x_rC","choiceBoxes":"toolbarselects_choiceBoxes__WYp-1","simpleField":"toolbarselects_simpleField__VKfLB"};